<template>
	<div class="table-area">
		<div class="tabel-area-content">
			<div class="operation-bar">
				<search-form ref="searchFormRef" />
				<el-button v-show="!editing" v-click-blur class="btn" type="primary" @click="handleQueryClick">
					查 询
				</el-button>
				<el-button v-show="!editing" v-click-blur class="btn" type="default" @click="handleResetQueryClick">
					重 置
				</el-button>
				<el-button v-show="!editing" v-click-blur class="btn" type="primary" @click="handleCheckClick">
					新 增
				</el-button>
				<el-button v-show="!editing" v-click-blur class="btn" type="primary" @click="handleEditClick">
					编 辑
				</el-button>
				<el-button
					v-show="!editing"
					:disabled="selectedRows.length < 1"
					v-click-blur
					class="btn"
					type="danger"
					@click="handleDeleteClick"
				>
					删 除
				</el-button>
				<el-button v-show="editing" v-click-blur class="cancel-btn" @click="handleCancelClick">取 消</el-button>
				<el-button v-show="editing" v-click-blur class="btn" type="primary" @click="handleConfirmClick">
					确 认
				</el-button>
			</div>
			<div class="table-wrapper" v-loading="loading">
				<gc-table
					ref="deviceTable"
					border
					showPage
					need-type="selection"
					:total="total"
					:columns="columns"
					:table-data="tableData"
					:current-page.sync="currentPage"
					:page-size="pageSize"
					@current-page-change="pageChange"
					@size-change="handleSizeChange"
					@selectChange="handleSelectChange"
				>
					<template #userTypeId="{ index }">
						<span>{{ userTypeMap[tableData[index].userTypeId] }}</span>
					</template>
					<template #eventLevel="{ index }">
						<el-select v-model="tableData[index].eventLevel" size="mini" :disabled="!editing">
							<el-option
								v-for="option in alarmLevelList"
								:key="option.value"
								:label="option.label"
								:value="option.value"
							></el-option>
						</el-select>
					</template>
					<template #comparisonValue="{ index }">
						<el-input-number
							v-if="showComparisonName"
							v-model="tableData[index].comparisonValue"
							:disabled="!editing"
							:min="1"
							step-strictly
							:step="1"
						></el-input-number>
						<template v-else>
							<span>--</span>
						</template>
					</template>
					<template #pushWechat="{ index }">
						<el-checkbox
							v-model="tableData[index].pushWechat"
							:true-label="SWITCH_STATUS.active"
							:false-label="SWITCH_STATUS.deactive"
							:disabled="!editing"
						></el-checkbox>
					</template>
					<template #pushSms="{ index }">
						<el-checkbox
							v-model="tableData[index].pushSms"
							:true-label="SWITCH_STATUS.active"
							:false-label="SWITCH_STATUS.deactive"
							:disabled="!editing"
						></el-checkbox>
					</template>
					<template #pushPage="{ index }">
						<el-checkbox
							v-model="tableData[index].pushPage"
							:true-label="SWITCH_STATUS.active"
							:false-label="SWITCH_STATUS.deactive"
							:disabled="!editing"
						></el-checkbox>
					</template>
					<template #pushVoice="{ index }">
						<el-checkbox
							v-model="tableData[index].pushVoice"
							:true-label="SWITCH_STATUS.active"
							:false-label="SWITCH_STATUS.deactive"
							:disabled="!editing"
						></el-checkbox>
					</template>
				</gc-table>
			</div>
		</div>
		<DedicatedAlarmDialog
			:show.sync="dialogShow"
			:data="{ id, name }"
			:show-comparison-name="showComparisonName"
			@success="handleSuccess"
		/>
	</div>
</template>

<script>
import {
	apiGetSpecialAlarmConfig,
	apiDeleteSpecialAlarmConfig,
	apiEditSpecialAlarmConfig,
} from '@/apis/waterAlarmConfig.api'
import SearchForm from '../components/search-form/index.vue'
import DedicatedAlarmDialog from './dialog/index.vue'
import { columns } from './config'

const SWITCH_STATUS = {
	active: '1',
	deactive: '0',
}

export default {
	name: 'ConfigTable',
	components: {
		SearchForm,
		DedicatedAlarmDialog,
	},
	props: {
		id: {
			type: Number,
			default: undefined,
		},
		name: {
			type: String,
			default: '',
		},
		showComparisonName: {
			type: Boolean,
			default: false,
		},
	},
	data() {
		return {
			SWITCH_STATUS,
			dialogShow: false,
			loading: false,
			columns,
			total: 1,
			tableData: [],
			// 用于比较提取出修改了的数据项，以及回滚
			tableDataBackUp: [],
			currentPage: 1,
			pageSize: 20,
			editing: false,
			userTypeMap: {},
			selectedRows: [],
			searchParams: {},
		}
	},
	computed: {
		alarmLevelList() {
			return (this.$store.getters.dataList.alarmLevel || []).map(item => ({
				label: item.name,
				value: item.defaultValue,
			}))
		},
	},
	mounted() {
		this.userTypeMap = { 0: '全部', ...this.extractMap(this.$store.getters.dataList.userType) }
		this.handleQueryClick()
	},
	activated() {
		if (this.id) {
			this.handleQueryClick()
		}
	},
	watch: {
		id() {
			this.handleQueryClick()
		},
	},
	methods: {
		handleQueryClick() {
			this.currentPage = 1
			this.getTableData({ current: 1 })
		},
		handleResetQueryClick() {
			this.$refs.searchFormRef.resetSearchParams()
			this.handleQueryClick()
		},
		handleCheckClick() {
			this.dialogShow = true
		},
		handleSelectChange(rows) {
			this.selectedRows = rows
		},
		handleDeleteClick() {
			this.$confirm('确定删除勾选的数据吗？', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning',
			}).then(() => {
				this.deleteSelectedRows(this.selectedRows)
			})
		},
		handleEditClick() {
			this.tableDataBackUp = JSON.parse(JSON.stringify(this.tableData))
			this.editing = true
		},
		handleCancelClick() {
			this.editing = false
			this.refreshTable()
		},
		handleConfirmClick() {
			const editedTableData = this.extractEditedData(this.tableData, this.tableDataBackUp)
			const data = this.generateTableParams(editedTableData, this.id)
			this.updateTableData(data)
			this.editing = false
		},
		handleSuccess() {
			this.$emit('update')
			this.handleQueryClick()
		},
		generateTableParams(tabelData, eventId) {
			const pushTypeArray = ['pushWechat', 'pushSms', 'pushPage', 'pushVoice']

			return tabelData.map(item => ({
				eventId,
				waterDeviceEventModelConfigId: item.waterDeviceEventModelConfigId,
				eventLevel: item.eventLevel,
				comparisonValue: item.comparisonValue,
				pushCreateBIds: pushTypeArray
					.map((key, index) => (item[key] === SWITCH_STATUS.active ? index + 1 : undefined))
					.filter(item => item !== undefined)
					.join(','),
			}))
		},
		updateTableData(data) {
			Promise.all(data.map(item => apiEditSpecialAlarmConfig(item)))
				.then(() => {
					this.$message.success('修改成功')
				})
				.catch(() => {})
				.finally(() => {
					this.refreshTable()
				})
		},
		pageChange(current) {
			this.currentPage = current
			this.getTableData({ current })
		},
		handleSizeChange(size) {
			this.pageSize = size
			this.currentPage = 1
			this.getTableData({ current: 1 })
		},
		deleteSelectedRows(rows) {
			const requests = rows.map(row =>
				apiDeleteSpecialAlarmConfig({ waterDeviceEventModelConfigId: row.waterDeviceEventModelConfigId }),
			)

			Promise.allSettled(requests)
				.then(results => {
					if (results.every(result => result.status === 'fulfilled')) {
						this.$message.success('删除成功')
					} else {
						this.$message.error('删除失败')
					}
				})
				.finally(() => {
					this.$emit('update')
					this.getTableData({ current: 1 })
				})
		},
		refreshTable() {
			this.getTableData({ current: this.currentPage })
		},
		extractEditedData(newData, oldData) {
			return newData.filter((row, index) => {
				const oldRow = oldData[index]
				const compareArray = ['eventLevel', 'comparisonValue', 'pushWechat', 'pushSms', 'pushPage', 'pushVoice']
				return compareArray.some(key => row[key] !== oldRow[key])
			})
		},
		generateParams(params) {
			return {
				eventId: this.id,
				size: this.pageSize,
				current: this.currentPage,
				...this.searchParams,
				...params,
			}
		},
		async getTableData(data) {
			this.searchParams = this.$refs.searchFormRef.getSearchParams()
			console.log('searchParams:', this.searchParams)
			const caliber = this.searchParams.caliber
			const caliberNum = Number(caliber)
			if (
				!!caliber &&
				(isNaN(caliberNum) || Math.floor(caliberNum) !== caliberNum || caliberNum < 1 || caliberNum > 2000)
			)
				return this.$message.warning('口径只能为1-2000之间的整数')
			const params = this.generateParams(data)
			const res = await this.queryTableData(params)
			this.tableData = res.records
			this.total = res.total
		},
		queryTableData(params) {
			this.loading = true
			return apiGetSpecialAlarmConfig(params)
				.then(res => res)
				.catch(() => ({ records: [], total: 0 }))
				.finally(() => {
					this.loading = false
				})
		},
		extractMap(list) {
			return Object.fromEntries(list.map(item => [item.defaultValue, item.name]))
		},
	},
}
</script>

<style scoped lang="scss">
.table-area {
	display: flex;
	flex-direction: column;
	height: 100%;
	overflow: hidden;
}

.tabel-area-content {
	flex: 1;
	display: flex;
	flex-direction: column;
	padding: 20px 12px 0 12px;
	overflow: hidden;
}
.operation-bar {
	display: flex;
	flex-wrap: wrap;
}

.btn {
	border-radius: 8px;
	&:nth-of-type(1) {
		margin-left: 12px;
	}
	&:nth-of-type(2) {
		margin-right: auto;
	}
}

.cancel-btn {
	margin-left: auto;
}

.table-wrapper {
	flex: 1;
	padding-top: 10px;
	overflow: hidden;
}
</style>
